export default {
   auth: {
      token: null,
      user: null,
      isAuthenticating: false,
      isAuthenticated: false,
      roles: [],
      error: null,
      isPristine: true,
      key:null
   }
};